import api from "./api";
import URLS from "../utils/urls.js";

export const multiSharePermissions = payload => {
  return api.post(URLS.BACKEND_API + `/api/permissions/add_permission`, {
    ...payload
  });
};
